<template>
  <b-nav-item>
    <b-form-select
      v-model="selected"
      @change="changeCompanySelect"
    >
      <option
        v-for="(selectOption, indexOpt) in options"
        :key="indexOpt"
        :value="selectOption.id"
      >
        {{ selectOption.title }}
      </option>
    </b-form-select>

  </b-nav-item>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import { computed } from '@vue/composition-api'
import { BNavItem, BFormSelect } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import Vue from 'vue'
import CompanyService from '@/services/company.service'
import router from '@/router'

export default {
  components: {
    BNavItem,
    BFormSelect,
  },
  data() {
    return {
      item: {
        label: 'some text goes here',
        inputType: 'text',
      },
      selected: '',
      options: [],
      relSel: false,
    }
  },
  async created() {
    await CompanyService.getList().then(
      // eslint-disable-next-line consistent-return
      async res => {
        if (res.status === 'success') {
          const list = []
          const rels = {}
          if ('result' in res && 'data' in res.result && res.result.data.length > 0) { ///
            Vue.prototype.$isUser = true
            this.$root.$emit('component2', true)
            this.selected = res.result.data[0]._id
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i <= res.result.data.length - 1; i++) {
              // eslint-disable-next-line no-underscore-dangle
              this.options.push({ id: res.result.data[i]._id, title: res.result.data[i].title })
              list.push(res.result.data[i]._id)
              // eslint-disable-next-line no-underscore-dangle
              rels[res.result.data[i]._id] = res.result.data[i].rel
            }
            this.options.push({ id: -1, title: 'ایجاد شرکت جدید' })
            if (localStorage.getItem('companySelected') !== null && list.includes(localStorage.getItem('companySelected'))) {
              this.selected = localStorage.getItem('companySelected')
            } else {
              // eslint-disable-next-line no-underscore-dangle
              localStorage.setItem('companySelected', this.selected)
            }
          } else { // بدون شرکت
            this.options.push({ id: -1, title: 'ایجاد شرکت جدید' })
            this.selected = -1
            if (this.$route.path !== '/company') router.push({ path: '/company' })
            this.sidebarMenu = false
            Vue.prototype.$isCreator = false
            Vue.prototype.$isUser = false
            this.$root.$emit('component1', false)
            this.$root.$emit('component2', false)
            return null
          }
          if (rels[this.selected] === 2) { // 1: Creator , 2: personal, 3:admin
            this.$root.$emit('component1', false)
            Vue.prototype.$isCreator = false
          } else {
            this.$root.$emit('component1', true)
            Vue.prototype.$isCreator = true
          }

          if (!rels[this.selected]) {
            if (this.$route.path !== '/tick/map') router.push({ path: '/tick/map' })
          }
        }
      },
      error => {
        this.message = (error.response && error.response.data)
              || error.message
              || error.toString()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'register error',
            text: this.message,
            icon: 'XIcon',
            variant: 'danger',
          },
        })
      },
    )
  },
  setup() {
    const { skin } = useAppConfig()

    const isDark = computed(() => skin.value === 'dark')

    return { skin, isDark }
  },

  methods: {
    changeCompanySelect(value) {
       if (value === -1) {
         this.$root.$emit('component1', false)
         this.$root.$emit('component2', false)
        router.push({ path: '/company/add' })
      }else {
         localStorage.setItem('companySelected', value)
         this.$router.go()
       }

      // }
    },
  },
}
</script>
